import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';
import { useMutation, useQuery } from 'react-query';
import { UserResponse } from '../types';

export type propsDTO = {
  email: string;
};

export const generateOtp = (
  data: propsDTO
): Promise<UserResponse> => {
  return axios.post('/generate-otp', data);
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof generateOtp>;
};

export const useGenerateOTP = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Otp sent successfully on your email',
      });
    },
    ...config,
    mutationFn: generateOtp,
  });
};